import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useFieldArray, useForm } from 'react-hook-form';
import { useBillingModeData } from '~/components/BillModal/components/BillingDate/useBillingModeData';
import { initialItemsForDefault } from './useBillItems.utils';
export const useBillClientForm = (param)=>{
    let { defaultItem, dateContext, startEmptyWhenUntouched = false } = param;
    const { billModeOptions, defaultMode, defaultIssueDate } = useBillingModeData({
        invoiceDateInfo: dateContext.invoiceDateInfo,
        effectiveDate: dateContext.effectiveDate,
        earliestBillableDate: dateContext.earliestBillableDate
    });
    const form = useForm({
        mode: 'onSubmit',
        defaultValues: {
            items: startEmptyWhenUntouched ? initialItemsForDefault(defaultItem) : [
                defaultItem
            ],
            mode: defaultMode,
            issueDate: defaultIssueDate
        }
    });
    const itemsControl = useFieldArray({
        control: form.control,
        name: 'items'
    });
    return _object_spread_props(_object_spread({}, form), {
        itemsControl,
        billModeOptions
    });
};
